module.exports = __webpack_public_path__ + "static/media/Macao.3b9ae4a7.png";